<script>
export default {
  name: "SideBarLogo",
};
</script>

<template>
  <a href="#" class="brand-link">
    <img
      src="../../assets/logo.png"
      alt="Logo"
      class="brand-image img-circle elevation-3"
      style="opacity: 0.8"
    />
    <span class="brand-text font-weight-light">TM Central</span>
  </a>
</template>
